import { render, staticRenderFns } from "./PointAddCustomer.vue?vue&type=template&id=d4dfdac6&"
import script from "./PointAddCustomer.vue?vue&type=script&lang=js&"
export * from "./PointAddCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PointAddCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports